import { theme } from "antd";
import { ExtendedGlobalToken } from "src/type.ts";

export function useCustomToken() {
  const { token } = theme.useToken() as unknown as {
    token: ExtendedGlobalToken;
  };
  return token;
}
